import ViewTreeView from "./ViewTreeView";
export { getCheckedValues, getHierarchyIds } from "./ViewTreeView";

export default ViewTreeView;
